import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {CheckboxTreeFilterOption} from "../../search-filter/checkbox-tree-filter/checkbox-tree-filter-option";
import {toggleJobFilterValue} from "../../store/actions/filter.actions";
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {setAcceptCookieDate} from "../../store/actions/user.actions";

@Component({
  selector: 'brt-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss']
})
export class CookieComponent implements OnInit, Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  currentSettings: number[] = [];

  // allSelected = localStorage.getItem("brt_privacy_google_maps") === "true" && localStorage.getItem("brt_privacy_google_analytics") === "true" && localStorage.getItem("brt_privacy_google_facebook") === "true";
  // someSelected = localStorage.getItem("brt_privacy_google_maps") === "true" || localStorage.getItem("brt_privacy_google_analytics") === "true" || localStorage.getItem("brt_privacy_google_facebook") === "true";

  groupedSettings: CheckboxTreeFilterOption[] = [
    {
      id: 0,
      title: "",
      selected: false,
      partiallySelected: false,
      children: [
        {
          // Functional
          id: 1,
          title: "",
          selected: false,
          partiallySelected: false,
          children: [
            {
              // Maps
              id: 2,
              title: "",
              selected: false,
              partiallySelected: false,
              children: [],
              disabled: false
            }
          ],
          disabled: false
        },
        {
          // Targeting
          id: 4,
          title: "",
          selected: false,
          partiallySelected: false,
          children: [
            {
              // Analytics
              id: 5,
              title: "",
              selected: false,
              partiallySelected: false,
              children: [],
              disabled: false
            }
          ],
          disabled: false
        },
        {
          // Marketing
          id: 7,
          title: "",
          selected: false,
          partiallySelected: false,
          children: [
            {
              // Facebook
              id: 8,
              title: "",
              selected: false,
              partiallySelected: false,
              children: [],
              disabled: false
            }
          ],
          disabled: false
        }
      ],
      disabled: false
    }
  ]
  settingsOpened = false;

  constructor(private store: Store<AppState>) {
  }

  ngOnInit() {
    // set inputs states on load
    if(localStorage.getItem("brt_privacy_google_maps") === "true") {
      this.onInputChanged(this.groupedSettings[0].children[0]);
    }
    if(localStorage.getItem("brt_privacy_google_analytics") === "true") {
      this.onInputChanged(this.groupedSettings[0].children[1]);
    }
    if(localStorage.getItem("brt_privacy_google_facebook") === "true") {
      this.onInputChanged(this.groupedSettings[0].children[2]);
    }
  }

  onInputChanged(option: CheckboxTreeFilterOption) {
    const newState = !(option.selected || option.partiallySelected);
    let toggleIDs: number[] = this.toggleAllChildren(option);
    if(newState) {
      toggleIDs.forEach((el) => {
        if(!this.currentSettings.includes(el)) this.currentSettings = [...this.currentSettings, el];
      });
    } else {
      this.currentSettings = this.currentSettings.filter((el) => !toggleIDs.includes(el));
    }
    this.groupedSettings = this.setAllState(this.groupedSettings);
    // console.log(option.partiallySelected);
  }

  toggleAllChildren(option: CheckboxTreeFilterOption): number[] {
    const toggleIDs: number[] = [];

    if(option.children.length) {
      option.children.forEach((subOption) => {
        if(subOption.children.length) {
          toggleIDs.push(...this.toggleAllChildren(subOption));
        } else {
          toggleIDs.push(subOption.id);
        }
      });
    } else {
      toggleIDs.push(option.id);
    }

    return toggleIDs;
  }

  setAllState(options: CheckboxTreeFilterOption[]): CheckboxTreeFilterOption[] {
    const newOptions: CheckboxTreeFilterOption[] = options.map((el) => {

      if(el.children.length) {
        el.children = this.setAllState(el.children);
        const treeState = this.getTreeState(el);
        el.selected = treeState === 2;
        el.partiallySelected = treeState === 1;
      } else {
        el.selected = this.currentSettings.includes(el.id);
      }

      return el;
    });

    console.log('cookie-set-all-state', newOptions);
    return newOptions;
  }

  /** 0 - not selected and no children selected */
  /** 1 - has children and any of children selected */
  /** 2 - selected or all children selected */
  getTreeState(option: CheckboxTreeFilterOption): number {
    if(option.children.length) {
      let anyChecked = false;
      let parentState = 2;
      let states: number[] = []
      for(let i = 0; i < option.children.length; i++) {
        states.push(this.getTreeState(option.children[i]));
      }
      if(states.filter(el => el !== 0).length === 0) return 0;
      if(states.filter(el => el !== 2).length === 0) return 2;
      return 1;
    } else {
      if(option.selected) return 2;
      return 0;
    }
  }

  toggleAccordion($event: MouseEvent) {
    const targetEl = $event.target as HTMLElement;

    if(!targetEl.classList.contains("cookie__settings-row-accordion-content-wrapper") && !targetEl.closest(".cookie__settings-row-accordion-content-wrapper")) {
      if(targetEl.classList.contains("cookie__settings-row-content")) {
        targetEl.classList.toggle("opened");
      } else {
        const parentEl = targetEl.closest(".cookie__settings-row-content");
        if(parentEl) {
          parentEl.classList.toggle("opened");
        }
      }
    }
  }

  openSettings() {
    this.settingsOpened = true;
  }

  accept(acceptAll = false) {

    if(acceptAll) {
      localStorage.setItem("brt_privacy_set", "true");
      localStorage.setItem("brt_privacy_google_maps", "true");
      localStorage.setItem("brt_privacy_google_analytics", "true");
      localStorage.setItem("brt_privacy_google_facebook", "true");
    } else {
      localStorage.setItem("brt_privacy_set", "true");
      localStorage.setItem("brt_privacy_google_maps", this.groupedSettings[0].children[0].children[0].selected.toString());
      localStorage.setItem("brt_privacy_google_analytics", this.groupedSettings[0].children[1].children[0].selected.toString());
      localStorage.setItem("brt_privacy_google_facebook", this.groupedSettings[0].children[2].children[0].selected.toString());
    }

    console.log("Google Maps", this.groupedSettings[0].children[0].children[0].selected);
    console.log("Analytics", this.groupedSettings[0].children[1].children[0].selected);
    console.log("Facbook", this.groupedSettings[0].children[2].children[0].selected);

    this.store.dispatch(setAcceptCookieDate());
    this.onClosed.emit(true);
  }
}
